import { TPaginationSettings } from '../../lib/interfaces/Pagination';
import { API_METHODS, BASE_URL, createHeader } from '../endpointBuilder';
import { axiosRequest } from '../request';

type CancelSubscriptionOrder = {
	subscriptionId: number;
	orderId: number;
};

const endpoints = {
	getOrders: (pagination?: TPaginationSettings | null) => {
		let url = `${BASE_URL}/order`;
		if (pagination) {
			const { page, limit } = pagination;
			url = `${BASE_URL}/order?page=${page}&limit=${limit}`;
		}
		return {
			headers: createHeader(null, true),
			url,
			method: API_METHODS.GET,
		};
	},
	createOrder: (data: FormData) => ({
		method: API_METHODS.POST,
		url: `${BASE_URL}/order`,
		headers: createHeader(null, true),
		data,
	}),
	cancelSubscriptionOrder: (data: CancelSubscriptionOrder) => ({
		method: API_METHODS.POST,
		url: `${BASE_URL}/order/cancel-subscription-order`,
		headers: createHeader(null, true),
		data,
	}),
};

export const getOrders = async (pagination: TPaginationSettings | null) =>
	axiosRequest(endpoints.getOrders(pagination));

export const createOrder = async (data: FormData) =>
	axiosRequest(endpoints.createOrder(data));

export const cancelSubscriptionOrder = async (data: CancelSubscriptionOrder) =>
	axiosRequest(endpoints.cancelSubscriptionOrder(data));
